if (!customElements.get("product-form")) {
  customElements.define("product-form", class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.LOADING_CLASS = "button--loading";

      this.hideErrors = this.dataset.hideErrors === "true";
      this.form.querySelector("[data-variant-id]").disabled = false;
      this.form.addEventListener("submit", event => this.onSubmitHandler(event));

      if (this.cart) this.submitButton?.setAttribute("aria-haspopup", "dialog");
    }

    /**
     * Handles the form submission.
     * @param event
     */
    onSubmitHandler(event) {
      event.preventDefault();

      const isDisabled = this.submitButton.getAttribute("aria-disabled") === "true";

      if (isDisabled) return;

      this.handleErrorMessage();

      this.submitButton.setAttribute("aria-disabled", "true");
      this.submitButton.classList.add(this.LOADING_CLASS);

      const formData = new FormData(this.form);
      const config = this.getConfig(formData);

      this.addUpsellsToFormData(formData);
      this.fetchCart(config, formData);
    }

    /**
     * Generates the fetch configuration.
     * @param formData
     * @returns {{method: string, headers: {"Content-Type": string, Accept: string}}}
     */
    getConfig(formData) {
      const config = fetchConfig("javascript");
      const sections = this.cart.getSectionsToRender().map(section => section.id);

      config.headers["X-Requested-With"] = "XMLHttpRequest";

      delete config.headers["Content-Type"];

      if (this.cart) {
        formData.append("sections", sections);
        formData.append("sections_url", window.location.pathname);

        this.cart.setActiveElement(document.activeElement);
      }

      config.body = formData;

      return config;
    }

    /**
     * Finds any selected upsell/addition inputs and adds them to the form data.
     * @param {FormData} formData
     */
    addUpsellsToFormData(formData) {
      const upsellInputs = document.querySelectorAll("[data-addition][data-input]");

      let index = 1;

      upsellInputs.forEach(input => {
        const value = input.value?.trim();

        if (!input.checked) return;
        if (!value || value === "") return;

        formData.append(`items[${index}][id]`, value);

        index++;
      });
    }

    /**
     * Fetches the cart and handles the response.
     * @param config
     * @param formData
     */
    fetchCart(config, formData) {
      fetch(`${routes.cart_add_url}`, config)
        .then(response => response.json())
        .then(response => this.handleResponse(response, formData))
        .catch((e) => console.error(e))
        .finally(() => this.handleState());
    }

    /**
     * Handles the fetch response.
     * @param response
     * @param formData
     * @returns {*}
     */
    handleResponse(response, formData) {
      if (response.status) this.handleErrorMessage(response.description);
      else if (!this.cart) return window.location = window.routes.cart_url;

      if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {
        source: "product-form",
        productVariantId: formData.get("id")
      });

      this.error = false;
      this.cart.renderContents(response);
    }

    /**
     * Handles the state of the form after the fetch.
     */
    handleState() {
      this.submitButton.classList.remove(this.LOADING_CLASS);

      if (!this.error) this.submitButton.removeAttribute("aria-disabled");

      const isEmpty = this.cart && this.cart.classList.contains("cart-drawer--is-empty");

      if (isEmpty) this.cart.classList.remove("cart-drawer--is-empty");
    }

    /**
     * Handles the error message display.
     * @param errorMessage
     */
    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors || !this.errorMessage) return;

      this.errorMessage.toggleAttribute("hidden", !errorMessage);

      if (errorMessage) this.errorMessage.textContent = errorMessage;
    }

    /**
     * Returns the product form element.
     * @returns {HTMLFormElement}
     */
    get form() {
      return this.querySelector("[data-product-form]");
    }

    /**
     * Returns the cart drawer element.
     * @returns {HTMLElement}
     */
    get cart() {
      return document.querySelector("[data-cart-drawer]");
    }

    /**
     * Returns the add to cart button.
     * @returns {HTMLButtonElement}
     */
    get submitButton() {
      return this.querySelector("[data-add-to-cart]");
    }

    /**
     * Returns the product form element.
     * @returns {HTMLFormElement}
     */
    get errorMessage() {
      return this.querySelector("[data-error-message]");
    }
  });
}